import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & { title?: string };

function IconFrame({ title, children, ...props }: IconProps) {
  return (
    <svg viewBox="0 0 48 48" aria-hidden={title ? undefined : true} role={title ? "img" : undefined} {...props}>
      {title ? <title>{title}</title> : null}
      {children}
    </svg>
  );
}

export function HeartIcon(props: IconProps) {
  return <IconFrame {...props}><path d="M24 41S6 31 6 17.5C6 10 15 6 20.2 12.2L24 16.7l3.8-4.5C33 6 42 10 42 17.5 42 31 24 41 24 41Z" fill="currentColor" stroke="#17154a" strokeWidth="3" strokeLinejoin="round" /></IconFrame>;
}

export function GemIcon(props: IconProps) {
  return <IconFrame {...props}><path d="m24 4 14 8 5 12-19 20L5 24l5-12 14-8Z" fill="currentColor" stroke="#17154a" strokeWidth="3" strokeLinejoin="round" /><path d="m10 12 14 12 14-12M5 24h38M24 4v40" fill="none" stroke="#fff" strokeOpacity=".58" strokeWidth="2" /></IconFrame>;
}

export function CoinIcon(props: IconProps) {
  return <IconFrame {...props}><circle cx="24" cy="24" r="18" fill="currentColor" stroke="#17154a" strokeWidth="3" /><circle cx="24" cy="24" r="11" fill="none" stroke="#fff4b5" strokeWidth="3" /><path d="M24 15v18M19 19h8.5a4 4 0 0 1 0 8H19" fill="none" stroke="#9b5a16" strokeWidth="3" strokeLinecap="round" /></IconFrame>;
}

export function StarIcon(props: IconProps) {
  return <IconFrame {...props}><path d="m24 4 5.9 12 13.1 1.9-9.5 9.3 2.2 13.1L24 34.1l-11.7 6.2 2.2-13.1L5 17.9 18.1 16 24 4Z" fill="currentColor" stroke="#17154a" strokeWidth="3" strokeLinejoin="round" /></IconFrame>;
}

export function PauseIcon(props: IconProps) {
  return <IconFrame {...props}><rect x="11" y="8" width="10" height="32" rx="3" fill="currentColor" /><rect x="27" y="8" width="10" height="32" rx="3" fill="currentColor" /></IconFrame>;
}

export function SoundIcon({ muted = false, ...props }: IconProps & { muted?: boolean }) {
  return <IconFrame {...props}><path d="M7 20v8h8l10 8V12l-10 8H7Z" fill="currentColor" /><path d="M31 18c3 3 3 9 0 12M35 13c7 6 7 16 0 22" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />{muted ? <path d="M29 15 43 33M43 15 29 33" stroke="#e83b5a" strokeWidth="5" strokeLinecap="round" /> : null}</IconFrame>;
}

export function SettingsIcon(props: IconProps) {
  return <IconFrame {...props}><path d="m20 5 8 0 1.4 6a15 15 0 0 1 3.3 2l5.8-1.8 4 7-4.5 4.1a15 15 0 0 1 0 3.8l4.5 4.1-4 7-5.8-1.8a15 15 0 0 1-3.3 2L28 43h-8l-1.4-6a15 15 0 0 1-3.3-2l-5.8 1.8-4-7 4.5-4.1a15 15 0 0 1 0-3.8l-4.5-4.1 4-7 5.8 1.8a15 15 0 0 1 3.3-2L20 5Z" fill="currentColor" /><circle cx="24" cy="24" r="7" fill="#fff8e7" /></IconFrame>;
}

export function ArrowIcon({ direction = "right", ...props }: IconProps & { direction?: "left" | "right" | "up" }) {
  const transform = direction === "left" ? "rotate(180 24 24)" : direction === "up" ? "rotate(-90 24 24)" : undefined;
  return <IconFrame {...props}><path transform={transform} d="M7 19h22V9l14 15-14 15V29H7V19Z" fill="currentColor" stroke="#17154a" strokeWidth="3" strokeLinejoin="round" /></IconFrame>;
}

export function MagicIcon({ character, ...props }: IconProps & { character: "dragon" | "unicorn" }) {
  return <IconFrame {...props}>{character === "dragon" ? <path d="M27 4c2 10-8 12-3 21 2-6 6-8 9-13 9 12 8 28-8 32C11 47 3 34 10 24c0 8 4 10 7 10-5-12 2-21 10-30Z" fill="currentColor" stroke="#17154a" strokeWidth="3" strokeLinejoin="round" /> : <><path d="m7 32 23-23 5 5L12 37 7 32Z" fill="currentColor" stroke="#17154a" strokeWidth="3" /><path d="m35 4 2.4 6.1L44 12l-5 4.3 1.5 6.7-5.5-3.6-5.5 3.6 1.5-6.7-5-4.3 6.6-1.9L35 4Z" fill="#ffd65a" stroke="#17154a" strokeWidth="2" /></>}</IconFrame>;
}

export function ReplayIcon(props: IconProps) {
  return <IconFrame {...props}><path d="M10 16V5l5 4A18 18 0 1 1 7 29" fill="none" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" /><path d="m10 5 12 2-12 9V5Z" fill="currentColor" /></IconFrame>;
}

export function SpeakerIcon(props: IconProps) {
  return <SoundIcon {...props} />;
}

export function CrownIcon(props: IconProps) {
  return <IconFrame {...props}><path d="M6 13 16 23l8-16 8 16 10-10-4 25H10L6 13Z" fill="currentColor" stroke="#17154a" strokeWidth="3" strokeLinejoin="round" /><circle cx="16" cy="29" r="3" fill="#55d7d5" /><circle cx="24" cy="29" r="3" fill="#a95cff" /><circle cx="32" cy="29" r="3" fill="#ef415d" /></IconFrame>;
}
